import { MethodType } from '../constants/MethodType'

const api = require('./api')

export const fetchCrossDataSource = (params, id) => api.request(1, `/crossDataSources/${id || ''}`, MethodType.GET, params)

export const addCrossDataSource = params => api.request(1, '/crossDataSources', MethodType.POST, params)

export const modCrossDataSource = (id, params) => api.request(1, `/crossDataSources/${id}`, MethodType.PUT, params)

export const delCrossDataSource = (id, params) => api.request(1, `/crossDataSources/${id}`, MethodType.DELETE, params)
